import React from 'react'

const Title = (props: JSX.IntrinsicElements['h2']) => {
  const { children, className, ...rest } = props
  return (
    <h2
      className={`xs:mb-2 xs:text-4xl mx-auto mb-2 max-w-2xl text-center text-4xl leading-none sm:mb-3 sm:text-5xl md:mb-5 md:text-6xl ${className}`}
      {...rest}
    >
      {children}
    </h2>
  )
}

export default Title
